import Title from "components/atoms/Title";
import FaqsGroup from "components/molecules/FaqsGroup";

/* ========== */

const Component = ({
  data,
  title,
  description,
  defaultActiveKey,
  multipleOpen,
  buttonClass,
  panelClass,
}) => {
  return (
    <>
      <Title
        text={title || "Frequently Asked Questions"}
        className="mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 
                            lg:text-bbc-40px "
      />
      {description ? (
        description.trim().length > 0 && (
          <p className="mb-6 text-center lg:mb-10">{description}</p>
        )
      ) : (
        // <p className="text-center mb-6 lg:mb-10">
        //   Know more about our nominee service with commonly asked questions.
        // </p>
        <></>
      )}
      <FaqsGroup
        data={data}
        haveTabs={!Array.isArray(data)}
        defaultActiveKey={defaultActiveKey || false}
        multipleOpen={multipleOpen || false}
        buttonClass={buttonClass}
        panelClass={panelClass}
      />
    </>
  );
};

export default Component;
